<template>
    <ModalComponent
        :name="name"
        title="Gestionar solicitudes de preventa"
        v-on:close="() => close(false)"
    >
        <b-row>
            <b-col cols="12" class="mb-3">
                <p class="mb-0">
                    Desde aquí podéis revisar y gestionar todas las solicitudes realizadas durante la preventa.
                </p>
                <p class="mb-3">
                    El sistema utiliza un <b>nivel de riesgo</b> para decidir qué solicitudes se aceptan o se deniegan automáticamente.
                </p>
                <div class="p-2 bg-light rounded border">
                    <b class="d-block mb-2">¿Cómo funciona?</b>

                    Las solicitudes con un nivel de riesgo <b>igual o superior</b> al valor seleccionado serán <b>denegadas automáticamente</b> al confirmar.

                    <div class="mt-2">
                        El nivel de riesgo se calcula automáticamente en función del comportamiento de la solicitud.
                        Valores más altos indican mayor probabilidad de que se trate de envíos automatizados (bots),
                        intentos de fraude o actividad sospechosa.
                    </div>
                </div>
            </b-col>
            <b-col cols="12" class="mt-2">
                <h5 class="d-md-flex align-items-center justify-content-between text-muted mb-2">
                    <span>
                        Riesgo seleccionado: 
                        <b class="riesgo-valor">{{ riesgo }}</b>
                    </span>
                    <span class="small d-block">
                        Se denegarán solicitudes con riesgo >= a este valor
                    </span>
                </h5>
                <div class="range-container">
                    <input
                        type="range"
                        min="0"
                        max="5"
                        step="0.5"
                        id="riesgo"
                        v-model="riesgo"
                        class="form-range custom-range"
                    />
                </div>
                <small class="text-muted">
                    Puedes ajustarlo de 0.5 en 0.5 (mínimo 0, máximo 5).
                </small>
            </b-col>
            <b-col cols="12" class="mt-4 text-right">
                <Button @click="terminar()" :disabled="loading">
                    <i v-if="loading" class="fas fa-spinner fa-spin mr-1"></i>
                    Confirmar gestión de solicitudes
                </Button>
            </b-col>
        </b-row>
    </ModalComponent>
</template>

<script setup>
    import { ref, computed, getCurrentInstance } from 'vue'
    import store from '@/store'
    import ModalComponent from "@/components/backend/components/ModalComponent"

    const props = defineProps({
        name: String,
        evento_id: [String, Number]
    })

    const emit = defineEmits(['close'])

    const instance = getCurrentInstance();
    const toast = instance?.proxy.$toast;

    const loading = ref(false)
    const riesgo = ref(3)

    const close = recargar => {
        emit('close', props.name, recargar)
    }

    const terminar = async() => {
        loading.value = true

        const params = {
            evento_id: props.evento_id,
            nivel_riesgo_aceptable: riesgo.value,
            filters: {}
        }

        try {
            const res = await store.dispatch('BACK_EVENTS_PREVENTA_GESTIONAR_SOLICITUDES', params)
            toast.success(res.data.message)
            close(true)
        } catch (error) {
            console.error('Error al gestionar:', error)
            toast.error('Error al procesar las solicitudes')
        } finally {
            loading.value = false
        }
    }
</script>

<style scoped>
    .custom-range {
        height: 8px;
        border-radius: 10px;
        appearance: none;
        outline: none;
    }
    .custom-range::-webkit-slider-thumb {
        appearance: none;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #343a40;
        border: 3px solid #fff;
        box-shadow: 0 0 6px rgba(0,0,0,0.25);
        cursor: pointer;
    }
    .custom-range::-moz-range-thumb {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #343a40;
        cursor: pointer;
    }
    .riesgo-valor {
        font-size: 1.4rem;
        color: #343a40;
    }
</style>